export const routes = ( prefix ) => [
    {
        path: `/${prefix}/morgue/service-packages`,
        name: `${prefix}.morgue.service-packages.index`,
        component: () => import('./service-packages/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.morgue.service-packages.index`,
                PageDescription: "Morgue service package listing",
            },
        },
    },
    {
        path: `/${prefix}/morgue/beds`,
        name: `${prefix}.morgue.beds.index`,
        component: () => import('./beds/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.morgue.beds.index`,
                PageDescription: "Morgue beds listing",
            },
        },
    },
];
